import { Plugin, registerPlugin } from '@capacitor/core';

export interface SerialPlugin extends Plugin {
  initialize(): Promise<{ value: string }>;
  stop(): Promise<{ value: string }>;
}

const Serial = registerPlugin<SerialPlugin>('Serial');

export default Serial;
